const jupiterQuiz = [ 
    {
    question: "Jupiter adalah planet ke berapa dari Matahari?",
    options: ["3", "4", "5", "6"],
    answer: 2,
  },
  {
    question: "Jupiter dikenal sebagai planet apa?",
    options: [
      "Planet Es",
      "Planet Terestrial",
      "Planet Raksasa Gas",
      "Planet Kecil",
    ],
    answer: 2,
  },
  {
    question: "Bintik merah besar di Jupiter disebut?",
    options: [
      "Red Storm",
      "Great Red Spot",
      "Big Red Hole",
      "Jupiter Eye",
    ],
    answer: 1,
  },
  {
    question: "Apa yang menyebabkan Bintik Merah Besar di Jupiter?",
    options: [
      "Gunung berapi",
      "Lautan lava",
      "Badai raksasa",
      "Tabrakan asteroid",
    ],
    answer: 2,
  },
  {
    question: "Berapa jumlah bulan yang dimiliki Jupiter?",
    options: ["12", "27", "53", "Banyak (lebih dari 70)"],
    answer: 3,
  },
  {
    question: "Bulan terbesar Jupiter bernama?",
    options: [
      "Europa",
      "Io",
      "Ganymede",
      "Callisto",
    ],
    answer: 2,
  },
  {
    question: "Apakah Jupiter memiliki cincin seperti Saturnus?",
    options: [
      "Tidak sama sekali",
      "Ya, sangat besar",
      "Ya, tetapi sangat tipis",
      "Hanya terlihat dari Bumi",
    ],
    answer: 2,
  },
  {
    question: "Jupiter tersusun terutama dari?",
    options: [
      "Batu dan logam",
      "Air dan es",
      "Gas hidrogen dan helium",
      "Pasir dan debu",
    ],
    answer: 2,
  },
  {
    question: "Waktu rotasi Jupiter (1 hari di Jupiter) adalah?",
    options: [
      "Sekitar 10 jam",
      "24 jam",
      "7 hari",
      "365 hari",
    ],
    answer: 0,
  },
  {
    question: "Mengapa Jupiter penting bagi tata surya?",
    options: [
      "Karena paling panas",
      "Karena paling dekat Matahari",
      "Karena gravitasinya melindungi planet lain",
      "Karena memiliki kehidupan",
    ],
    answer: 2,
  },
]

export default jupiterQuiz;